import React, { useEffect, useState, useRef } from 'react';
import { useData } from '../../../contexts';
import { Grid } from '@mui/material';
import useSWR from 'swr';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import {
  EvolutieChartTabel,
  GemeenteDropdown,
  OptiesDropdown,
  KaartGemeenten,
  SimpleBarchartNoGroups,
  SpreidingGemeenten,
  SpreidingGemeentenGrouped,
  BarChartGrouped,
  SimpleBarchartGrouped,
  EvolutieChartGemeenten,
  EvolutieChartTabelGrouped,
  KaartGemeentenGrouped,
  BarChartStackedGrouped,
} from './DetailPageComponents/DetailPageComponents';
import { ArrowNavigationInteractieveDetail } from '../../ArrowNavigation/ArrowNavigationInteractieve';
import html2canvas from 'html2canvas';
import { navigate } from 'gatsby';
import { ShareButton } from '../../ShareButton/ShareButton';

export const InteractieveToolDetail = (props: any) => {
  const {
    colors,
    benchColors,
    gemeenteColor,
    vgColor,
    selectedGemeente,
    selectedBenchmarks,
    selectedIndicator,
    selectedIndicatorData,
    blobUrlSpreiding,
    blobUrlSamenvattingen,
    blobUrlClustersIndicatoren,
    blobUrl,
    locale,
    clusterColorsInteractieve,
    interfaceColor,
    blobUrlBron,
  } = useData();

  const { additionalData, detailData, refUp, refDown, refCurrent } = props;

  const imageRef = useRef(null);

  const [clusterData, setClusterData] = useState([]);
  const [clusterDataDesc, setClusterDataDesc] = useState([]);
  const [deeplink, setDeeplink] = useState('');
  const [scatterShartOneDimensionalProps, setScatterShartOneDimensionalProps] =
    useState([
      {
        id: 0,
        fieldName: 'Vlaams Gewest',
        type: 'main',
        size: 1000,
      },
      {
        id: 1,
        fieldName: 'Aalst',
        type: 'benchmark',
        size: 300,
      },
    ]);

  const [
    scatterShartOneDimensionalPropsGemeente,
    setScatterShartOneDimensionalPropsGemeente,
  ] = useState([
    {
      id: 0,
      fieldName: 'Test',
      type: 'optie',
      size: 1000,
    },
  ]);

  const prepProps = () => {
    const tmp = [
      {
        id: 0,
        fieldName: selectedGemeente.label,
        type: 'main',
        size: 1000,
      },
    ];

    selectedBenchmarks.forEach((d: any, i: any) => {
      tmp.push({
        id: i + 1,
        fieldName: d.label,
        type: 'benchmark',
        size: 300,
      });
    });

    let propsGemeente = [];

    opties.forEach((d: any, i: any) => {
      propsGemeente.push({
        id: i + 1,
        fieldName: d,
        type: 'optie',
        size: 300,
      });
    });

    setScatterShartOneDimensionalProps(tmp);
    setScatterShartOneDimensionalPropsGemeente(propsGemeente);
  };

  const [opties, setOpties] = useState([]);
  const [optiesLvl2, setoptiesLvl2] = useState([]);
  const [gemeenten, setGemeenten] = useState([]);
  const [stackedBarData, setStackedBarData] = useState([]);
  const [stackedBarLvl2Data, setStackedBarLvl2Data] = useState([]);
  const [lineChartData, setLineChartData] = useState([]);
  const [lineChartDataGemeente, setLineChartDataGemeente] = useState([]);
  const [colorsLineGemeente, setColorsLineGemeente] = useState([]);
  const [colorsLine, setColorsLine] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [jaren, setJaren] = useState([]);
  const [selectedOptie, setSelectedOptie] = useState('');
  const [selectedOptieGemeente, setSelectedOptieGemeente] = useState('');
  const [spreidingData, setSpreidingData] = useState([]);
  const [joinKey, setJoinKey] = useState('-1');

  const [gemeentenV2, setGemeentenV2] = useState([]);
  const [selectedOptieGemeenteV2, setSelectedOptieGemeenteV2] = useState('');

  const colorsBar = [gemeenteColor].concat(benchColors);

  const handleClickDownloadCSV = () => {
    let url = `${blobUrlBron}gemeentestadsmonitor_${detailData?.detail?.ido}.csv`;
    detailData?.detail?.ido !== undefined &&
      detailData?.detail?.ido !== null &&
      window.open(url);
  };

  const handleClickDownloadPNG = (id: any, fileName: any) => {
    const table: any = document.getElementById(id);

    html2canvas(table).then(function (canvas) {
      const link = document.createElement('a');
      link.download = fileName + '.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  };

  const handleClickMoreInfo = () => {
    const ind = additionalData.allIndicators.find((a: any) => {
      return a.field_indicator_id === detailData?.detail?.ido;
    });

    window.open(`${ind.path.alias}`, '_blank');
  };

  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {
    // revalidateOnFocus: false,
    // revalidateOnMount: false,
    // revalidateOnReconnect: false,
    // refreshWhenOffline: false,
    // refreshWhenHidden: false,
    // refreshInterval: 0,
  };

  const { data: f_spreiding_indicator } = useSWR(
    `${blobUrlSpreiding}f_spreiding_indicator_${joinKey}.json`,
    fetcher,
    swrOptions,
  );

  const { data: f_samenvatting_indicatoren } = useSWR(
    `${blobUrlSamenvattingen}f_samenvatting_indicatoren.json`,
    fetcher,
    swrOptions,
  );

  const { data: d_cluster_indicatoren } = useSWR(
    `${blobUrlClustersIndicatoren}d_cluster_indicatoren.json`,
    fetcher,
    swrOptions,
  );

  const { data: f_cluster_indicator } = useSWR(
    `${blobUrlClustersIndicatoren}f_cluster_indicator_${joinKey}.json`,
    fetcher,
    swrOptions,
  );

  const { data: d_ruimte } = useSWR(
    `${blobUrl}d_ruimte.json`,
    fetcher,
    swrOptions,
  );

  const prepOpties = () => {
    if (detailData === undefined || detailData.id === -1) return;

    const tmpOpties: any[] = [];
    const tmpOptiesLvl2: any[] = [];
    if (detailData?.topLevel === 2) {
      const tmpOpties: any[] = [];
      detailData.data[0].data.forEach((d: any) => {
        tmpOpties.push(d.indicatorLabel);
      });

      const tmpData1: any[] = [];
      detailData.data.forEach((d: any) => {
        tmpData1.push(d.indicatorLabel);
      });

      tmpData1.forEach((d, i) => {
        tmpOpties.forEach((s: any, i: number) => {
          const label = `${d} - ${s}`;
          tmpOptiesLvl2.push(label);
        });
      });

      setSelectedOptie(tmpOptiesLvl2[0]);

      setOpties(tmpOpties);
      setoptiesLvl2(tmpOptiesLvl2);
    } else {
      detailData.data.forEach((d: any) => {
        tmpOpties.push(d.indicatorLabel);
      });

      setSelectedOptie(tmpOpties[0]);
      setOpties(tmpOpties);
    }
  };

  const prepGemeenten = () => {
    const tmpGemeenten: any[] = [];

    tmpGemeenten.push(selectedGemeente.label);
    if (detailData?.detail?.visualisatieType !== 'V_Top') {
      selectedBenchmarks.forEach((d: any, i: number) => {
        tmpGemeenten.push(d.label);
      });
    }

    if (detailData?.topLevel === 2) {
      const tmpOpties: any[] = [];
      detailData.data.forEach((d: any) => {
        tmpOpties.push(d.indicatorLabel);
      });

      const tmpData: any[] = [];
      tmpGemeenten.forEach((d, i) => {
        tmpOpties.forEach((s: any, i: number) => {
          const label = `${d} - ${s}`;
          tmpData.push(label);
        });
      });

      const tmpOptiesV2: any[] = [];
      detailData.data[0].data.forEach((d: any) => {
        tmpOptiesV2.push(d.indicatorLabel);
      });

      const tmpDataV2: any[] = [];
      tmpGemeenten.forEach((d, i) => {
        tmpOptiesV2.forEach((s: any, i: number) => {
          const label = `${d} - ${s}`;
          tmpDataV2.push(label);
        });
      });

      setSelectedOptieGemeente(tmpData[0]);
      setGemeenten(tmpData);
      setSelectedOptieGemeenteV2(tmpDataV2[0]);
      setGemeentenV2(tmpDataV2);
    } else {
      setSelectedOptieGemeente(tmpGemeenten[0]);
      setGemeenten(tmpGemeenten);
    }
  };

  const prepStackedBarData = () => {
    if (detailData === undefined || detailData.id === -1) return;

    const tmpGemeenten: any[] = [];
    tmpGemeenten.push(selectedGemeente.label);
    if (detailData?.detail?.visualisatieType !== 'V_Top') {
      selectedBenchmarks.forEach((d: any, i: number) => {
        tmpGemeenten.push(d.label);
      });
    }

    const tmpOpties: any[] = [];
    detailData.data.forEach((d: any) => {
      tmpOpties.push(d.indicatorLabel);
    });

    if (detailData?.topLevel === 2) {
      const tmpData: any[] = [];
      tmpGemeenten.forEach((d, i) => {
        tmpOpties.forEach((s: any, i: number) => {
          const o: any = {};
          o.name = `${d} - ${s}`;
          o.color = i === 0 ? gemeenteColor : benchColors[i - 1];
          o.d3format = detailData.data[0].d3format;

          detailData.data[i].data.forEach((b: any, i: number) => {
            o[b.indicatorLabel] = b[d];
            o.d3format = b.d3format;
          });
          tmpData.push(o);
        });
      });

      setStackedBarData(tmpData);

      const tmpData1: any[] = [];
      detailData.data.forEach((d: any) => {
        tmpData1.push(d.indicatorLabel);
      });

      const tmpOpties1: any[] = [];
      detailData.data[0].data.forEach((d: any) => {
        tmpOpties1.push(d.indicatorLabel);
      });

      // tmpData1.forEach((d, i) => {
      //   tmpOpties.forEach((s: any, i: number) => {
      //     const label = `${d} - ${s}`;
      //     tmpOptiesLvl2.push(label);
      //   });
      // });

      const tmpData2: any[] = [];
      const row = detailData.data.find((a: any) => {
        return a.indicatorLabel === selectedOptie.split(' - ')[0];
      });
      const newData = row?.data.find((d: any) => {
        return d.indicatorLabel === selectedOptie.split(' - ')[1];
      });

      tmpGemeenten.forEach((d, i) => {
        const o: any = {};
        o.name = d;
        o.color = i === 0 ? gemeenteColor : benchColors[i - 1];
        o.d3format = detailData?.data[0]?.data[0]?.d3format;
        o.maxJaar = detailData?.maxJaar;

        o[selectedOptie] = newData?.[d];

        tmpData2.push(o);
      });

      setStackedBarLvl2Data(tmpData2);
    } else {
      const tmpData: any[] = [];
      tmpGemeenten.forEach((d, i) => {
        const o: any = {};
        o.name = d;
        o.color = i === 0 ? gemeenteColor : benchColors[i - 1];
        o.d3format = detailData?.data[0]?.d3format;
        o.maxJaar = detailData?.maxJaar;
        tmpOpties.forEach((s: any, i: number) => {
          o[s] = detailData.data[i][d];
        });
        tmpData.push(o);
      });

      setStackedBarData(tmpData);
    }
  };

  const prepLineChartData = () => {
    if (detailData === undefined || detailData.id === -1) return;

    if (detailData?.topLevel === 2) {
      const optie0 = selectedOptie.split(' - ')[0];
      const optie1 = selectedOptie.split(' - ')[1];

      let tmpData = detailData.data.find(
        (d: any) => d.indicatorLabel === optie0,
      );
      let data = tmpData?.data.find((d: any) => d.indicatorLabel === optie1);

      if (data === undefined || data.length === 0) return;

      let allData: any = [];
      let flat: any = [];
      let colorsLines: any = [gemeenteColor].concat(benchColors);
      let jaren: any = [];

      const selectedRuimtes = [selectedGemeente].concat(selectedBenchmarks);

      selectedRuimtes.forEach((d, i) => {
        let a: any = {};
        a.id = i;
        a.key = i;
        a.gemeente = d.ruimte;
        a.survey = detailData?.detail?.survey;
        a.d3format = detailData?.data[0].data[0]?.d3format;

        data[d.ruimte + '_10'] &&
          data[d.ruimte + '_10'].forEach((item: any) => {
            allData.push(item);

            a[item.jaar] = item.value;
            jaren.push(item.jaar);
          });
        flat.push(a);
      });

      jaren.sort((a: any, b: any) => a - b);
      const jarenUnique: any = [...new Set(jaren)];

      allData.sort((a: any, b: any) => a.jaar - b.jaar);

      const categories = [...new Set(allData.map((d: any) => d.jaar))];

      const out: any = categories.map((d) => {
        let a: any = {};

        a.jaar = d;
        a.d3format = data.d3format;
        a.survey = detailData?.detail?.survey;
        a.isPrognose = ['V_Waarde_Prog', 'V_Categorie_Prog'].includes(
          detailData?.detail?.visualisatieType,
        );
        a[selectedGemeente.ruimte] = allData.find(
          (all: any) =>
            parseInt(all.jaar) === parseInt(d) &&
            parseInt(all.idRuimte) === parseInt(selectedGemeente.idRuimte),
        )?.value;
        selectedBenchmarks.forEach((bench: any, i: number) => {
          a[bench.ruimte] = allData.find(
            (all: any) =>
              parseInt(all.jaar) === parseInt(d) &&
              parseInt(all.idRuimte) === parseInt(bench.idRuimte),
          )?.value;
        });
        return a;
      });

      setColorsLine(colorsLines);
      setTableData(flat);
      setJaren(jarenUnique);
      setLineChartData(out);
    } else {
      let data = detailData.data.find(
        (d: any) => d.indicatorLabel === selectedOptie,
      );

      if (data === undefined || data.length === 0) return;
      // const data = detailData.data[0];

      let allData: any = [];
      let flat: any = [];
      let colorsLines: any = [gemeenteColor].concat(benchColors);
      let jaren: any = [];

      const selectedRuimtes = [selectedGemeente].concat(selectedBenchmarks);

      selectedRuimtes.forEach((d, i) => {
        let a: any = {};
        a.id = i;
        a.key = i;
        a.gemeente = d.ruimte;
        a.survey = detailData?.detail?.survey;
        a.d3format = detailData.data[0]?.d3format;
        a.indicator = detailData.data[0]?.indicatorLabel;
        data[d.ruimte + '_10'] &&
          data[d.ruimte + '_10'].forEach((item: any) => {
            allData.push(item);

            a[item.jaar] = item.value;
            jaren.push(item.jaar);
          });
        flat.push(a);
      });

      jaren.sort((a: any, b: any) => a - b);
      const jarenUnique: any = [...new Set(jaren)];

      allData.sort((a: any, b: any) => a.jaar - b.jaar);

      const categories = [...new Set(allData.map((d: any) => d.jaar))];
      const out: any = categories.map((d) => {
        let a: any = {};

        a.jaar = d;
        a.d3format = data.d3format;
        a.survey = detailData?.detail?.survey;
        a.isPrognose = ['V_Waarde_Prog', 'V_Categorie_Prog'].includes(
          detailData?.detail?.visualisatieType,
        );
        a[selectedGemeente.ruimte] = allData.find(
          (all: any) =>
            parseInt(all.jaar) === parseInt(d) &&
            parseInt(all.idRuimte) === parseInt(selectedGemeente.idRuimte),
        )?.value;
        selectedBenchmarks.forEach((bench: any, i: number) => {
          a[bench.ruimte] = allData.find(
            (all: any) =>
              parseInt(all.jaar) === parseInt(d) &&
              parseInt(all.idRuimte) === parseInt(bench.idRuimte),
          )?.value;
        });
        return a;
      });

      setColorsLine(colorsLines);
      setTableData(flat);
      setJaren(jarenUnique);
      setLineChartData(out);
    }
  };

  const prepLineChartDataGemeente = () => {
    if (detailData === undefined || detailData.id === -1) return;

    if (detailData?.topLevel === 2) {
      // parse selectedoptie
      const gemeente = selectedOptieGemeente.split(' - ')[0];
      const optie = selectedOptieGemeente.split(' - ')[1];

      let data = detailData.data.find((d: any) => d.indicatorLabel === optie);

      if (data === undefined || data.length === 0) return;
      data = data.data;

      let allData: any = [];
      let colorsLines: any = [gemeenteColor].concat(benchColors);

      let jaren: any = [];

      data.forEach((d: any, i: number) => {
        d[gemeente + '_10'] &&
          d[gemeente + '_10'].forEach((item: any) => {
            item.indicatorLabel = d.indicatorLabel;
            allData.push(item);
            jaren.push(item.jaar);
          });
      });

      jaren.sort((a: any, b: any) => a - b);
      const jarenUnique: any = [...new Set(jaren)];

      allData.sort((a: any, b: any) => a.jaar - b.jaar);

      const categories = [...new Set(allData.map((d: any) => d.jaar))];

      const out: any = categories.map((d) => {
        let a: any = {};
        a.jaar = d;
        a.d3format = data[0].d3format;
        a.survey = detailData?.detail?.survey;
        a.isPrognose = ['V_Waarde_Prog', 'V_Categorie_Prog'].includes(
          detailData?.detail?.visualisatieType,
        );
        opties.forEach((optie: any, i: number) => {
          a[optie] = allData.find(
            (all: any) =>
              parseInt(all.jaar) === parseInt(d) &&
              all.indicatorLabel === optie,
          )?.value;
        });
        return a;
      });

      setColorsLineGemeente(colorsLines);
      setLineChartDataGemeente(out);
    } else {
      let data = detailData.data;

      if (data === undefined || data.length === 0) return;

      let allData: any = [];
      let colorsLines: any = [gemeenteColor].concat(benchColors);
      let jaren: any = [];

      data.forEach((d: any, i: number) => {
        d[selectedOptieGemeente + '_10'] &&
          d[selectedOptieGemeente + '_10'].forEach((item: any) => {
            item.indicatorLabel = d.indicatorLabel;
            allData.push(item);
            jaren.push(item.jaar);
          });
      });

      jaren.sort((a: any, b: any) => a - b);
      const jarenUnique: any = [...new Set(jaren)];

      allData.sort((a: any, b: any) => a.jaar - b.jaar);

      const categories = [...new Set(allData.map((d: any) => d.jaar))];

      const out: any = categories.map((d) => {
        let a: any = {};
        a.jaar = d;
        a.d3format = data[0].d3format;
        a.survey = detailData?.detail?.survey;
        a.isPrognose = ['V_Waarde_Prog', 'V_Categorie_Prog'].includes(
          detailData?.detail?.visualisatieType,
        );
        opties.forEach((optie: any, i: number) => {
          a[optie] = allData.find(
            (all: any) =>
              parseInt(all.jaar) === parseInt(d) &&
              all.indicatorLabel === optie,
          )?.value;
        });
        return a;
      });

      setColorsLineGemeente(colorsLines);
      setLineChartDataGemeente(out);
    }
  };

  const onChangeOptieHandler = (d: any) => {
    setSelectedOptie(JSON.parse(d.target.value));
  };

  const onChangeOptieGemeenteHandler = (d: any) => {
    setSelectedOptieGemeente(JSON.parse(d.target.value));
  };

  const onChangeOptieGemeenteV2Handler = (d: any) => {
    setSelectedOptieGemeenteV2(JSON.parse(d.target.value));
  };

  const prepSpreidingData = () => {
    const benchmarkIds = [...new Set(selectedBenchmarks.map((d: any) => d.id))];

    const sam = f_samenvatting_indicatoren.filter(
      (d: any) => d.joinKey === joinKey,
    );

    const vlgew = sam.map((d: any) => {
      const a: any = {};
      a.isVlaamsGewest = true;
      a.value = d.valueVlaamsGewest;
      a.ruimte = 'Vlaams Gewest';
      a.joinKey = d.joinKey;
      a.idRuimte = 2000;
      a.d3format = f_spreiding_indicator[0].d3format;
      return a;
    });

    const allSpreiding = f_spreiding_indicator.concat(vlgew);

    const spreiding = allSpreiding.map((d: any) => {
      const isMain = d.idRuimte === selectedGemeente.id ? true : false;
      const isBench = benchmarkIds.includes(d.idRuimte) ? true : false;
      const indexBench = benchmarkIds.indexOf(d.idRuimte);

      if (detailData?.topLevel === 2) {
        d.d3format =
          detailData &&
          detailData.data &&
          detailData.data.length > 0 &&
          detailData.data[0].data &&
          detailData.data[0].data.length > 0
            ? detailData.data[0].data[0].d3format
            : null;
      } else {
        d.d3format =
          detailData && detailData.data && detailData.data.length > 0
            ? detailData.data[0].d3format
            : null;
      }

      d.y = 0;
      d.z = isMain || isBench ? 120 : 100;

      d.color =
        isMain === true
          ? gemeenteColor
          : isBench === true
          ? benchColors[indexBench]
          : d.isVlaamsGewest === true
          ? vgColor
          : 'gray';
      d.isMain = isMain;
      d.isBench = isBench;

      return d;
    });

    setSpreidingData(spreiding);
  };

  useEffect(() => {
    prepOpties();
    prepGemeenten();
    // detailData &&
    //   detailData.data &&
    //   detailData.data.length > 0 &&
    //   setJoinKey(detailData.data[0].joinKey);

    if (detailData && detailData.data && detailData.data.length > 0)
      setJoinKey(
        detailData?.topLevel === 2
          ? detailData?.data[0]?.data[0]?.joinKey
          : detailData?.data[0]?.joinKey,
      );
  }, [detailData]);

  useEffect(() => {
    prepProps();
    prepStackedBarData();
    prepLineChartData();
    prepLineChartDataGemeente();

    if (f_spreiding_indicator && f_samenvatting_indicatoren) {
      prepSpreidingData();
    } else {
      setSpreidingData([]);
    }

    if (
      d_cluster_indicatoren &&
      f_cluster_indicator &&
      d_ruimte &&
      detailData
    ) {
      let newDetailData = structuredClone(detailData);
      if (newDetailData.topLevel === 2) {
        newDetailData = detailData.data[0];
      }

      const clusterDim = d_cluster_indicatoren
        .filter((d: any) => {
          return d.joinKey === joinKey;
        })
        .map((d: any) => {
          let out = '';

          if (newDetailData === undefined || newDetailData.data.length === 0) {
            out = d.clusterDesc;
          } else if (
            d.clusterOndergrens !== null &&
            d.clusterBovengrens !== null
          ) {
            out = `${locale.format(newDetailData.data[0].d3format)(
              d.clusterOndergrens,
            )}-${d.clusterBovengrensTeken}${locale.format(
              newDetailData.data[0].d3format,
            )(d.clusterBovengrens)}`;
          } else if (d.clusterOndergrens !== null) {
            out = `${d.clusterOndergrensTeken}${locale.format(
              newDetailData.data[0].d3format,
            )(d.clusterOndergrens)}`;
          } else if (d.clusterBovengrens !== null) {
            out = `${d.clusterBovengrensTeken}${locale.format(
              newDetailData.data[0].d3format,
            )(d.clusterBovengrens)}`;
          } else {
            out = d.clusterDesc;
          }
          d.clusterDesc = out;
          return d;
        });

      const clusterData = f_cluster_indicator.map((d: any) => {
        const cluster = clusterDim.find((a: any) => a.id === d.idCluster);
        const ruimte = d_ruimte.find((a: any) => a.id === d.idRuimte);

        d.clusterDesc = cluster ? cluster?.clusterDesc : null;
        d.clusterNummer = cluster ? cluster?.clusterNummer : null;
        d.ruimte = ruimte ? ruimte?.ruimte : null;
        d.formattedValue =
          newDetailData === undefined || newDetailData.data.length === 0
            ? d.waarde
            : locale.format(newDetailData?.data[0]?.d3format)(d.waarde);
        return d;
      });

      setClusterData(clusterData);
      setClusterDataDesc(clusterDim);
    } else {
      setClusterData([]);
      setClusterDataDesc([]);
    }
  }, [
    selectedGemeente,
    selectedBenchmarks,
    detailData,
    selectedOptie,
    selectedOptieGemeente,
    f_spreiding_indicator,
    f_samenvatting_indicatoren,
    d_cluster_indicatoren,
    f_cluster_indicator,
    d_ruimte,
    joinKey,
  ]);

  useEffect(() => {
    const trimmedUrl = window.location.href.split('?').shift();

    const url = `${trimmedUrl}?gemeente=${selectedGemeente.ruimte}&indicator=${selectedIndicatorData?.detail?.ido}`;
    setDeeplink(url);
  }, [selectedIndicatorData, selectedGemeente]);

  useEffect(() => {
    if (detailData === undefined || detailData.data === undefined) return;

    if (detailData?.topLevel === 2) {
      const row = detailData.data.find((a: any) => {
        return a.indicatorLabel === selectedOptie.split(' - ')[0];
      });
      const newData = row?.data.find((d: any) => {
        return d.indicatorLabel === selectedOptie.split(' - ')[1];
      });

      const newJoinKey = newData !== undefined ? newData.joinKey : '-1';

      setJoinKey(newJoinKey);
    } else {
      const tmp = detailData.data.find(
        (d: any) => d.indicatorLabel === selectedOptie,
      );
      const newJoinKey = tmp !== undefined ? tmp.joinKey : '-1';

      setJoinKey(newJoinKey);
    }
  }, [selectedOptie, detailData]);

  if (detailData === undefined || detailData.id === -1)
    return (
      <Grid
        item
        xs={12}
        pl={5}
        pr={5}
        height={'80vh'}
        minHeight={'400px'}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        Geen indicator geselecteerd
      </Grid>
    );
  else
    return (
      <Grid
        container
        // style={{ paddingLeft: '16px' }}
        id="detailVisualContainer"
        ref={imageRef}
      >
        <Grid
          item
          xs={12}
          sx={{
            position: 'sticky',
            top: '0px',
            background: '#fff',
            zIndex: '11',
            borderBottom: '1px solid #efefef',
            height: '110px',
          }}
        >
          <Grid container>
            <Grid item xs={10}>
              <div
                className={'vl-typography'}
                style={{
                  paddingLeft: '48px',
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  float: 'left',
                  width: '80%',
                }}
              >
                <h4 className="detailPage-title">
                  {detailData.indicatorLabel}
                </h4>
                <p className="detailPage-subtitle" style={{ maxWidth: '100%' }}>
                  {detailData?.detail?.definitie}
                </p>
                <p className="detailPage-subtitle" style={{ maxWidth: '100%' }}>
                  Bron: {detailData?.bron}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <ArrowNavigationInteractieveDetail
                up={refUp}
                down={refDown}
                current={refCurrent}
              />

              <div
                className={'vl-typography'}
                style={{
                  position: 'relative',
                  top: '20px',
                  right: '120px',
                  textAlign: 'right',
                }}
              >
                <Tooltip>
                  <TooltipTrigger
                    style={{
                      position: 'relative',
                      display: 'inline',
                    }}
                  >
                    <div
                      className={'vl-typography'}
                      style={{
                        cursor: 'pointer',
                        color: interfaceColor,
                        textDecoration: 'underline',
                        fontSize: '16px',
                      }}
                    >
                      <CopyToClipboard text={deeplink}>
                        <div
                          onClick={() => handleClickMoreInfo()}
                          style={{ marginBottom: 0 }}
                        >
                          Meer info
                        </div>
                      </CopyToClipboard>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent className="Tooltip">
                    Klik om meer info te bekomen over de geselecteerde indicator
                  </TooltipContent>
                </Tooltip>
              </div>

              <div
                className={'vl-typography'}
                style={{
                  position: 'relative',
                  top: '20px',
                  right: '120px',
                  textAlign: 'right',
                }}
              >
                <Tooltip>
                  <TooltipTrigger
                    style={{
                      position: 'relative',
                      display: 'inline',
                    }}
                  >
                    <div
                      className={'vl-typography'}
                      style={{
                        cursor: 'pointer',
                        color: interfaceColor,
                        textDecoration: 'underline',
                        fontSize: '16px',
                      }}
                    >
                      <CopyToClipboard text={deeplink}>
                        <div
                          // onClick={handleClickDeeplink}
                          style={{ marginBottom: 0 }}
                        >
                          Kopieer link
                        </div>
                      </CopyToClipboard>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent className="Tooltip">
                    Klik om de link voor de geselecteerde indicator te kopiëren
                  </TooltipContent>
                </Tooltip>
              </div>

              <div
                className={'vl-typography'}
                style={{
                  fontSize: '16px',
                  position: 'relative',
                  top: '20px',
                  right: '120px',
                  textAlign: 'right',
                }}
              >
                Download:
                <Tooltip>
                  <TooltipTrigger
                    onClick={() => handleClickDownloadCSV()}
                    style={{
                      paddingLeft: '8px',
                      cursor: 'pointer',
                      color: interfaceColor,
                      textDecoration: 'underline',
                      fontSize: '16px',
                      display: 'inline',
                    }}
                  >
                    csv
                  </TooltipTrigger>
                  <TooltipContent className="Tooltip">
                    Klik om de data te downloaden als csv-bestand
                  </TooltipContent>
                </Tooltip>
                <Tooltip>
                  <TooltipTrigger
                    onClick={() =>
                      handleClickDownloadPNG(
                        'detailVisualContainer',
                        detailData.indicatorLabel,
                      )
                    }
                    style={{
                      paddingLeft: '8px',
                      cursor: 'pointer',
                      color: interfaceColor,
                      textDecoration: 'underline',
                      display: 'inline',
                    }}
                  >
                    png
                  </TooltipTrigger>
                  <TooltipContent className="Tooltip">
                    Klik om de data te downloaden als png-bestand
                  </TooltipContent>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
          <ShareButton deeplink={deeplink} top={140} />
        </Grid>

        <Grid
          item
          xs={12}
          pl={0}
          pr={0}
          // height={'80vh'}
        >
          {detailData?.detail?.visualisatieType === 'V_Categorie_meerdere' && (
            <Grid container justifyContent="center">
              <BarChartStackedGrouped
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                gemeenten={gemeenten}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />

              {/* Optie split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de cijfers voor een combinatie van categorieën of
                      onderdelen
                    </h5>

                    <OptiesDropdown
                      opties={optiesLvl2}
                      onChangeOptieHandler={onChangeOptieHandler}
                      selectedOptie={selectedOptie}
                    />

                    {joinKey !== '-1' && (
                      <div>
                        <SimpleBarchartGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          stackedBarData={stackedBarLvl2Data}
                          opties={[selectedOptie]}
                          colorsBar={colorsBar}
                          locale={locale}
                        />

                        <SpreidingGemeentenGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          spreidingData={spreidingData}
                          locale={locale}
                        />

                        <EvolutieChartTabelGrouped
                          selectedBenchmarks={selectedBenchmarks}
                          lineChartData={lineChartData}
                          scatterShartOneDimensionalProps={
                            scatterShartOneDimensionalProps
                          }
                          colorsLine={colorsLine}
                          tableData={tableData}
                          jaren={jaren}
                          locale={locale}
                          detailData={detailData}
                        />

                        {/* <KaartGemeentenGrouped
                          detailData={detailData}
                          clusterData={clusterData}
                          clusterDataDesc={clusterDataDesc}
                          clusterColorsInteractieve={clusterColorsInteractieve}
                        /> */}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Gemeenten split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de evolutie voor een specifieke groep van één
                      gemeente of benchmark
                    </h5>

                    <GemeenteDropdown
                      gemeenten={gemeenten}
                      onChangeOptieGemeenteHandler={
                        onChangeOptieGemeenteHandler
                      }
                      selectedOptieGemeente={selectedOptieGemeente}
                    />

                    <EvolutieChartGemeenten
                      lineChartDataGemeente={lineChartDataGemeente}
                      scatterShartOneDimensionalPropsGemeente={
                        scatterShartOneDimensionalPropsGemeente
                      }
                      colorsLineGemeente={colorsLineGemeente}
                      locale={locale}
                      detailData={detailData}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {detailData?.detail?.visualisatieType === 'V_Bezoek' && (
            <Grid container justifyContent="center">
              <BarChartStackedGrouped
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                gemeenten={gemeenten}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />

              {/* Gemeenten split - andere optie combo */}
              {/* <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de evolutie voor een specifieke groep van één
                      gemeente of benchmark
                    </h5>

                    <GemeenteDropdown
                      gemeenten={gemeentenV2}
                      onChangeOptieGemeenteHandler={
                        onChangeOptieGemeenteV2Handler
                      }
                      selectedOptieGemeente={selectedOptieGemeenteV2}
                    />
                  </Grid>
                </Grid>
              </Grid> */}

              {/* Optie split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de cijfers voor een combinatie van categorieën of
                      onderdelen
                    </h5>

                    <OptiesDropdown
                      opties={optiesLvl2}
                      onChangeOptieHandler={onChangeOptieHandler}
                      selectedOptie={selectedOptie}
                    />

                    {joinKey !== '-1' && (
                      <div>
                        <SimpleBarchartGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          stackedBarData={stackedBarLvl2Data}
                          opties={[selectedOptie]}
                          colorsBar={colorsBar}
                          locale={locale}
                        />

                        <SpreidingGemeentenGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          spreidingData={spreidingData}
                          locale={locale}
                        />

                        <EvolutieChartTabelGrouped
                          selectedBenchmarks={selectedBenchmarks}
                          lineChartData={lineChartData}
                          scatterShartOneDimensionalProps={
                            scatterShartOneDimensionalProps
                          }
                          colorsLine={colorsLine}
                          tableData={tableData}
                          jaren={jaren}
                          locale={locale}
                          detailData={detailData}
                        />

                        {/* <KaartGemeentenGrouped
                          detailData={detailData}
                          clusterData={clusterData}
                          clusterDataDesc={clusterDataDesc}
                          clusterColorsInteractieve={clusterColorsInteractieve}
                        /> */}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Gemeenten split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de evolutie voor een specifieke groep van één
                      gemeente of benchmark
                    </h5>

                    <GemeenteDropdown
                      gemeenten={gemeenten}
                      onChangeOptieGemeenteHandler={
                        onChangeOptieGemeenteHandler
                      }
                      selectedOptieGemeente={selectedOptieGemeente}
                    />

                    <EvolutieChartGemeenten
                      lineChartDataGemeente={lineChartDataGemeente}
                      scatterShartOneDimensionalPropsGemeente={
                        scatterShartOneDimensionalPropsGemeente
                      }
                      colorsLineGemeente={colorsLineGemeente}
                      locale={locale}
                      detailData={detailData}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {detailData?.detail?.visualisatieType === 'V_Waarde_MultiCat' && (
            <Grid container justifyContent="center">
              <BarChartGrouped
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                gemeenten={gemeenten}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />

              {/* Optie split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de cijfers voor een combinatie van categorieën of
                      onderdelen
                    </h5>

                    <OptiesDropdown
                      opties={optiesLvl2}
                      onChangeOptieHandler={onChangeOptieHandler}
                      selectedOptie={selectedOptie}
                    />

                    {joinKey !== '-1' && (
                      <div>
                        <SimpleBarchartGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          stackedBarData={stackedBarLvl2Data}
                          opties={[selectedOptie]}
                          colorsBar={colorsBar}
                          locale={locale}
                        />

                        <SpreidingGemeentenGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          spreidingData={spreidingData}
                          locale={locale}
                        />

                        <EvolutieChartTabelGrouped
                          selectedBenchmarks={selectedBenchmarks}
                          lineChartData={lineChartData}
                          scatterShartOneDimensionalProps={
                            scatterShartOneDimensionalProps
                          }
                          colorsLine={colorsLine}
                          tableData={tableData}
                          jaren={jaren}
                          locale={locale}
                          detailData={detailData}
                        />

                        {/* <KaartGemeentenGrouped
                          detailData={detailData}
                          clusterData={clusterData}
                          clusterDataDesc={clusterDataDesc}
                          clusterColorsInteractieve={clusterColorsInteractieve}
                        /> */}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Gemeenten split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>
                      Bekijk de evolutie voor een specifieke groep van één
                      gemeente of benchmark
                    </h5>

                    <GemeenteDropdown
                      gemeenten={gemeenten}
                      onChangeOptieGemeenteHandler={
                        onChangeOptieGemeenteHandler
                      }
                      selectedOptieGemeente={selectedOptieGemeente}
                    />

                    <EvolutieChartGemeenten
                      lineChartDataGemeente={lineChartDataGemeente}
                      scatterShartOneDimensionalPropsGemeente={
                        scatterShartOneDimensionalPropsGemeente
                      }
                      colorsLineGemeente={colorsLineGemeente}
                      locale={locale}
                      detailData={detailData}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {(detailData?.detail?.visualisatieType === 'V_Waarde' ||
            detailData?.detail?.visualisatieType === 'V_Waarde_Prog' ||
            detailData?.detail?.visualisatieType === 'V_Waarde_neg' ||
            detailData?.detail?.visualisatieType === 'V_Aandeel') && (
            <Grid container justifyContent="center">
              <SimpleBarchartNoGroups
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />

              <SpreidingGemeenten
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                spreidingData={spreidingData}
                locale={locale}
              />

              <EvolutieChartTabel
                selectedBenchmarks={selectedBenchmarks}
                lineChartData={lineChartData}
                scatterShartOneDimensionalProps={
                  scatterShartOneDimensionalProps
                }
                colorsLine={colorsLine}
                tableData={tableData}
                jaren={jaren}
                locale={locale}
                detailData={detailData}
              />

              {/* <KaartGemeenten
                detailData={detailData}
                clusterData={clusterData}
                clusterDataDesc={clusterDataDesc}
                clusterColorsInteractieve={clusterColorsInteractieve}
              /> */}
            </Grid>
          )}

          {detailData?.detail?.visualisatieType === 'V_Top' && (
            <Grid container justifyContent="center">
              <BarChartGrouped
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                gemeenten={gemeenten}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />
            </Grid>
          )}

          {(detailData?.detail?.visualisatieType === 'V_Waarde_meerdere' ||
            detailData?.detail?.visualisatieType === 'V_Waarde_neg_meerdere' ||
            detailData?.detail?.visualisatieType === 'V_Aandeel_meerdere') && (
            <Grid container justifyContent="center">
              <BarChartGrouped
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                gemeenten={gemeenten}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />

              {/* Optie split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>Bekijk de cijfers voor één categorie of onderdeel</h5>

                    <OptiesDropdown
                      opties={opties}
                      onChangeOptieHandler={onChangeOptieHandler}
                      selectedOptie={selectedOptie}
                    />

                    {joinKey !== '-1' && (
                      <div>
                        <SimpleBarchartGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          stackedBarData={stackedBarData}
                          opties={[selectedOptie]}
                          colorsBar={colorsBar}
                          locale={locale}
                        />

                        <SpreidingGemeentenGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          spreidingData={spreidingData}
                          locale={locale}
                        />

                        <EvolutieChartTabelGrouped
                          selectedBenchmarks={selectedBenchmarks}
                          lineChartData={lineChartData}
                          scatterShartOneDimensionalProps={
                            scatterShartOneDimensionalProps
                          }
                          colorsLine={colorsLine}
                          tableData={tableData}
                          jaren={jaren}
                          locale={locale}
                          detailData={detailData}
                        />

                        {/* <KaartGemeentenGrouped
                          detailData={detailData}
                          clusterData={clusterData}
                          clusterDataDesc={clusterDataDesc}
                          clusterColorsInteractieve={clusterColorsInteractieve}
                        /> */}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Gemeenten split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>Bekijk de evolutie voor één gemeente of benchmark</h5>

                    <GemeenteDropdown
                      gemeenten={gemeenten}
                      onChangeOptieGemeenteHandler={
                        onChangeOptieGemeenteHandler
                      }
                      selectedOptieGemeente={selectedOptieGemeente}
                    />

                    <EvolutieChartGemeenten
                      lineChartDataGemeente={lineChartDataGemeente}
                      scatterShartOneDimensionalPropsGemeente={
                        scatterShartOneDimensionalPropsGemeente
                      }
                      colorsLineGemeente={colorsLineGemeente}
                      locale={locale}
                      detailData={detailData}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {(detailData?.detail?.visualisatieType === 'V_Categorie' ||
            detailData?.detail?.visualisatieType === 'V_Categorie_Prog' ||
            detailData?.detail?.visualisatieType === 'V_Cat' ||
            detailData?.detail?.visualisatieType === 'V_CatDetail') && (
            <Grid container justifyContent="center">
              <BarChartStackedGrouped
                detailData={detailData}
                selectedBenchmarks={selectedBenchmarks}
                stackedBarData={stackedBarData}
                gemeenten={gemeenten}
                opties={opties}
                colorsBar={colorsBar}
                locale={locale}
              />

              {/* Optie split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>Bekijk de cijfers voor één categorie of onderdeel</h5>

                    <OptiesDropdown
                      opties={opties}
                      onChangeOptieHandler={onChangeOptieHandler}
                      selectedOptie={selectedOptie}
                    />

                    {joinKey !== '-1' && (
                      <div>
                        <SimpleBarchartGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          stackedBarData={stackedBarData}
                          opties={[selectedOptie]}
                          colorsBar={colorsBar}
                          locale={locale}
                        />

                        <SpreidingGemeentenGrouped
                          detailData={detailData}
                          selectedBenchmarks={selectedBenchmarks}
                          spreidingData={spreidingData}
                          locale={locale}
                        />

                        <EvolutieChartTabelGrouped
                          selectedBenchmarks={selectedBenchmarks}
                          lineChartData={lineChartData}
                          scatterShartOneDimensionalProps={
                            scatterShartOneDimensionalProps
                          }
                          colorsLine={colorsLine}
                          tableData={tableData}
                          jaren={jaren}
                          locale={locale}
                          detailData={detailData}
                        />

                        {/* <KaartGemeentenGrouped
                          detailData={detailData}
                          clusterData={clusterData}
                          clusterDataDesc={clusterDataDesc}
                          clusterColorsInteractieve={clusterColorsInteractieve}
                        /> */}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Gemeenten split */}
              <Grid container justifyContent="center">
                <Grid
                  className={'vl-typography'}
                  item
                  xs={12}
                  sx={{
                    minWidth: '400px !important',
                    maxWidth: '800px !important',

                    margin: '12px',
                    padding: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '24px',
                    marginTop: '32px',
                    border: '1px solid #dddddd',
                    borderRadius: 2,
                  }}
                >
                  <Grid
                    className={'vl-typography'}
                    item
                    xs={12}
                    // height={450}
                    sx={{
                      minWidth: '400px !important',
                      maxWidth: '800px !important',
                      padding: '20px',
                    }}
                  >
                    <h5>Bekijk de evolutie voor één gemeente of benchmark</h5>

                    <GemeenteDropdown
                      gemeenten={gemeenten}
                      onChangeOptieGemeenteHandler={
                        onChangeOptieGemeenteHandler
                      }
                      selectedOptieGemeente={selectedOptieGemeente}
                    />

                    <EvolutieChartGemeenten
                      lineChartDataGemeente={lineChartDataGemeente}
                      scatterShartOneDimensionalPropsGemeente={
                        scatterShartOneDimensionalPropsGemeente
                      }
                      colorsLineGemeente={colorsLineGemeente}
                      locale={locale}
                      detailData={detailData}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} height={'32px'}></Grid>
      </Grid>
    );
};
